/**
 * ware-announcement-bar
 * Custom element that rotates 3 messages every 4 seconds.
 * Respects prefers-reduced-motion.
 */
class WareAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this._messages = [];
    this._current = 0;
    this._interval = null;
  }

  connectedCallback() {
    this._messages = Array.from(this.querySelectorAll('[data-message]'));
    if (this._messages.length <= 1) return;

    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return;

    this._showMessage(0);
    this._interval = setInterval(() => {
      this._current = (this._current + 1) % this._messages.length;
      this._showMessage(this._current);
    }, 4000);
  }

  disconnectedCallback() {
    if (this._interval) clearInterval(this._interval);
  }

  _showMessage(index) {
    this._messages.forEach((el, i) => {
      el.hidden = i !== index;
      el.setAttribute('aria-hidden', i !== index ? 'true' : 'false');
    });
    this.setAttribute('aria-label', this._messages[index].textContent.trim());
  }
}

customElements.define('ware-announcement-bar', WareAnnouncementBar);
